<template>
<FullCalendar 
    ref="fullCalendar" 
    :options="calendarOptions"
/>

</template>

<script>
import FullCalendar from "@fullcalendar/vue"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin from "@fullcalendar/interaction"
import deLocale from "@fullcalendar/core/locales/de"

export default {
    name: "StudentCalendar",
    components: {FullCalendar},
    data() {
        return {
            calendarOptions: {
                plugins: [ dayGridPlugin, interactionPlugin ],
                initialView: 'dayGridMonth',
                events: this.getEvents,
                contentHeight: "auto",
                height: "auto",
                /*weekNumbers: true,*/
                eventDidMount: this.eventRender
            }
        }
    },
    created() {
        if (window.locale && window.locale.length) {
            switch (window.locale) {
                case 'de':
                    this.calendarOptions['locale'] = deLocale
                    break;
                default:
                    break;
            }
        }
    },
    methods: {
        getEvents: function (arg, callback) {
            let $end = '/api/get-user-events';
            axios.post($end, {start: arg.start, end: arg.end}).then(function (response) {
                response = response.data;
                let events = [];
                if (response.data && response.data.length) {
                    response.data.forEach(function (event) {
                        events.push({
                            id: event.id,
                            title: event.training.title + " / "+event.section_name+" / " +event.courseEvent.name,
                            start: event.start_at,
                            end: event.end_at,
                            color: event.courseEvent.color
                        })
                    })
                }
                // console.log(events)
                callback(events)
            }).catch(err => {
                console.log(err);
                this.$data.loader = false;
            });
        },
        eventRender: function(info) {
            $(info.el).tooltip({ 
                title: info.event.title,
                placement: "top",
                trigger: "hover",
                container: "body"
              });
        },
    }
}
</script>

<style>
.fc-event-title-container > .fc-event-title {
    white-space: break-spaces;
    word-break: break-word;
}
</style>
